import {
    put, call, takeLatest
} from 'redux-saga/effects';
import { axios } from '../client';
import {GET_CONTENT, getContentFailure, getContentSuccess} from "../actions/content";


function* handleGetContent(action) {
    try {
        //Using just axios makes an unauthenticated call. If you need to be authenticated, use authenticatedAxious
        const response = yield call(axios.get,
            `${window.api_url}/site/page/content/${action.data}`
        );
        yield put(getContentSuccess(response.data));
    } catch (e) {
        yield put(getContentFailure());
    }
}
export function* watchGetContent() {
    yield takeLatest(GET_CONTENT, handleGetContent);
}